export const OTHER_HISTORY_TYPE = "other_history_type";
export const SET_VALUE = "set_value";
export const GET_OTHER_HISTORY = "get_other_history";
export const REQ_OTHER_HISTORY = "req_other_history";
